import { atom } from 'jotai';

import type { RecordingEntry } from '@/app-shell/rpa/recorder/model/types';

export const recordingsAtom = atom<readonly RecordingEntry[]>([]);
